import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

export interface MFAOptions {
  response: null;
  hasError: boolean;
  errorDisplay: null;
  errorDesc: null;
  errorNum: number;
  errorSubject: null;
  message: null;
  data: Datum[];
}

export interface Datum {
  id: string;
  code: string;
  displayMessage: string;
  expirationSeconds: string;
  expirationStartDate: string;
  device: Device;
}

export interface Device {
  email: null | string;
  phone: null | string;
  notificationDevice: null | string;
}

export interface ProcessMFAOptionRequest {
  userId: any ;
  code: string;
}

export interface SendOtpCodeRequst {
  subscriber: string;
  code: string;
}

export interface ValidateOtpCodeRequest {
  subscriber: string;
  code: string;
  userId: any;
}

export class PayloadMask {
  static maskData(dto: any) {
    var form = new FormData();
    let token: string = btoa(JSON.stringify(dto));
    form.append('token', token);
    return form;
  }
}


@Injectable({
  providedIn: 'root',
})
export class MfaService {
  public BASE_PATH = '/api';
  constructor(private http: HttpClient) {}

  getMFAOptions(userId: string) {
    var form = new FormData();
    form.append('id', userId);
    return this.http.post<MFAOptions>(
      `${this.BASE_PATH}` + '/Authenticate/GetMFAOptions',
      form
    );
  }

  processMFAOption(dto: ProcessMFAOptionRequest) {
    return this.http.post(
      `${this.BASE_PATH}` + '/Authenticate/ProcessMFAOption',
      PayloadMask.maskData(dto)
    );
  }

  sendOtpCode(dto: SendOtpCodeRequst) {
    return this.http.post(
      `${this.BASE_PATH}` + '/Authenticate/SendOtpCode',
      PayloadMask.maskData(dto)
    );
  }

  validateOtpCode(dto: ValidateOtpCodeRequest) {
    return this.http.post(
      `${this.BASE_PATH}` + '/Authenticate/ValidateOtpCode',
      PayloadMask.maskData(dto)
    );
  }

  ValidateNewDevice(dto: any) {
    return this.http.post(
      `${this.BASE_PATH}` + '/Authenticate/ValidateNewDevice',
      PayloadMask.maskData(dto)
    );
  }

  VerifyMFAStatus(dto: any) {
    return this.http.post(
      `${this.BASE_PATH}` + '/Authenticate/VerifyMFAStatus',
      PayloadMask.maskData(dto)
    );
  }

  RegisterUserDevice(dto: any) {
    return this.http.post(
      `${this.BASE_PATH}` + '/Authenticate/RegisterUserDevice',
      PayloadMask.maskData(dto)
    );
  }

  GetConfirmationData(dto: any) {
    return this.http.post(
      `${this.BASE_PATH}` + '/Authenticate/GetConfirmationData',
      PayloadMask.maskData(dto)
    );
  }

  SendConfirmationAnswer(dto: any) {
    return this.http.post(
      `${this.BASE_PATH}` + '/Authenticate/SendConfirmationAnswer',
      PayloadMask.maskData(dto)
    );
  }
}

